import { Link } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import { FUNCTION_CARDS } from '@/pages/home/constants';
import { CONVENIENCE_CARDS } from '@/pages/home/constants';
import FunctionCard from '@/pages/home/components/FunctionCard';
import ConvenienceCard from '@/pages/home/components/ConvenienceCard';

/**
 * 특별한 주요 기능 배너 컴포넌트
 * @returns JSX.Element
 */
const SpecialFunctionBanner = () => {
	return (
		<section className="main-feature main-section">
			<div className="main-feature-inner">
				<div className="title-group">
					<p className="sub">All-in-One BusinessWare</p>
					<p className="title">
						스타트업, 성장기업을 위해 <br />
						최적화된 ERP, 스텔라
					</p>
				</div>
				<div className="card-list feature1">
					<div className="card-title">
						<strong className="title">주요기능</strong>
						<Link to={`${NAV_PATH.FUNCTION.MAIN}`} className="text-link">
							전체보기
						</Link>
					</div>
					<ul className="card-group feature1">
						<FunctionCard items={[...FUNCTION_CARDS]} />
					</ul>
				</div>

				<div className="card-list feature2">
					<div className="card-title">
						<strong className="title">편의기능</strong>
						<Link to={`${NAV_PATH.FUNCTION.CONVENIENCE}`} className="text-link">
							전체보기
						</Link>
					</div>
					<ul className="card-group feature2">
						<ConvenienceCard items={[...CONVENIENCE_CARDS]} />
					</ul>
				</div>
			</div>
		</section>
	);
};

export default SpecialFunctionBanner;
